{% block hueb_seo_conversion_detail %}

    <sw-page class="hueb-seo-conversion-detail">
        <template #content>
            Loading...
        </template>
    </sw-page>
{% endblock %}
